import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import PosCartStore from '../../../stores/PosCartStore';

import { endPoints as EndPoints } from '../../../constants/PosConstants';

import Checkout from '../checkout/Checkout.react';
import Loyalty from '../loyalty/Loyalty.react';

import Price from '../../form/Price.react';
import { Fragment } from 'react';
import AjaxPromises from '../../../utils/AjaxPromises';

class CartSummary extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            logo : false,
            showAllotmentDetails : false,
            periodPurchased : false,
            fillDates : false,
            daysInPeriod : false
        };

    }

    componentDidMount() {
        var self = this;

        var formData = UserStore.getApiData();

        AjaxPromises.POST(EndPoints.LOAD_COMPANY_LOGO,
            formData).then(res =>  {
                if(res.Data && res.Data.length > 0) {
                    self.setState({ logo : res.Data[0].Logo });
                }
            }
        );
    }

    render() {
        var loc                  = UserStore.getApiData().LspId;
        var cart                 = this.props.cart;
        var guest                = this.props.guest;
        var appliedLoyaltyPoints = this.props.appliedLoyaltyPoints;
        var allotment            = this.props.allotment;
        let remotePayInfo        = this.props.remotePayInfo;
        var selectedLocation     = UserStore.getState().selectedLocation;
        var cartSummary          = PosCartStore.getCartSummary();
        var budTender            = UserStore.getState();
        var showDaysSupplyCalculator = budTender.selectedLocation.ShowDaysSupplyCalculator;
        var discountLabel = selectedLocation.ShowLeafLogixLoyalty ? 'TOTAL DISCOUNT & LOYALTY' : 'TOTAL DISCOUNT';
        let daysSupplyInCart = cart.reduce((value, cartItem) => value + cartItem.QtySelected * (cartItem.DaysSupply !== "" ? parseFloat(cartItem.DaysSupply) : 0), 0.00);
        let daysSupplyRemaining = this.props.guest.DaysSupplyRemaining;
        let prepayInfo = cartSummary.prepayInfo;
        let isPreauth = cartSummary.isPreauth;

        let gtiPayInfo = (prepayInfo || []).filter(x => x.PrepaymentType === 'gtipay');

        return (
            <div className='cart-summary'>

                {/* <img
                    src='/assets/logo.png'
                    className='cart-summary__logo' />

                <div className='cart-summary__bud-tender'>
                    <div>{budTender.user.FullName}</div>
                    <div>{budTender.selectedRegister.TerminalName}</div>
                    <div>{budTender.selectedLocation.location_name}</div>
                </div> */}


                <div className='cart-summary__stats'>
                    {remotePayInfo && remotePayInfo.RemotePayTransactionId
                        && (
                            <table>
                                <tbody>
                                    <tr className='cart-summary__remotePay--font'>
                                        <td style={{ width: 150 }}>
                                            REMOTE PAY STATUS
                                        </td>
                                        <td style={{ width: 120 }}>
                                            {remotePayInfo.RemotePayPaidOn ? 'COMPLETE' : 'PENDING' }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )
                    }
                    {gtiPayInfo && gtiPayInfo.length > 0
                        && (
                            <table>
                                <tbody>
                                    <tr className='cart-summary__remotePay--font'>
                                        <td style={{ width: 180 }}>
                                            BANK TRANSFER PREAUTH:
                                        </td>
                                        <td style={{ width: 90 }}>
                                        ${gtiPayInfo.reduce((result, x) => result + x.Amount, 0).toFixed(2)}
                                        </td>                                        
                                    </tr>
                                </tbody>
                            </table>
                        )
                    }

                    { showDaysSupplyCalculator ?
                        <table>
                            <tbody>
                                <tr>
                                    <td>Days Supply</td>
                                    <td>In Cart / Remaining</td>
                                </tr>
                                <tr>
                                    <td>Current</td>
                                    <td>{daysSupplyInCart != null ? daysSupplyInCart : '-'} / {daysSupplyRemaining != null ? daysSupplyRemaining : '-'}</td>
                                </tr>
                            </tbody>                            
                        </table>
                        :
                        <React.Fragment>                
                            { this.state.showAllotmentDetails ?
                                <table>
                                    <tbody>
                                        <tr
                                            style={{'cursor' : 'pointer'}}
                                            onClick={() => { this.setState({ showAllotmentDetails : false }); }}
                                        >
                                            <td colSpan={2}><i className='fa fa-angle-up fa-lg' style={{ marginLeft: -12 }}/>Allotment Details</td>
                                        </tr>
                                        <tr>
                                            <td>Category</td>
                                            <td>In Cart / Used / Limit</td>
                                        </tr>
                                        {
                                            allotment.details.map((data) => 
                                        <tr>
                                            <td>{data.Category || 'All Categories'}</td>
                                            <td>{data.InCart}g / {data.Used}g / {data.Limit}g</td>
                                        </tr>
                                            )
                                        }
                                    </tbody>                            
                                </table>
                                :
                                <table>
                                    <tbody>
                                        { selectedLocation.CompanyFlag === 'Dispensary' &&
                                            <tr
                                                style={{'cursor' : 'pointer'}}
                                                onClick={() => { this.setState({ showAllotmentDetails : true }); }}                                    
                                            >
                                                <td><i className='fa fa-angle-down fa-lg' style={{ marginLeft: -12 }}/>Allotment</td>
                                                <td>{(parseFloat(allotment.total) || 0).toFixed(2)}g</td>
                                            </tr>
                                        }
                                        { selectedLocation.CompanyFlag === 'Dispensary' &&
                                            <tr>
                                                <td>In Cart</td>
                                                <td>{(parseFloat(allotment.cart) || 0).toFixed(2)}g</td>
                                            </tr>
                                        }
                                        {/* { selectedLocation.CompanyFlag === 'Dispensary' &&
                                            <tr>
                                                <td>Used</td>
                                                <td>{(allotment.used || 0).toFixed(2)}g</td>
                                            </tr>
                                        } */}
                                        { selectedLocation.CompanyFlag === 'Dispensary' &&
                                            <tr>
                                                <td className={(allotment.remaining < 0 ? 'cart-summary__stats--warning' : '')}>Remaining</td>
                                                <td className={(allotment.remaining < 0 ? 'cart-summary__stats--warning' : '')}>{(parseFloat(allotment.remaining) || 0).toFixed(2)}g</td>
                                            </tr>
                                        }
                                        { selectedLocation.ShowLeafLogixLoyalty &&
                                            <React.Fragment>
                                                <tr>
                                                    <td>Loyalty Available</td>
                                                    <td>{guest.LoyaltyPoints}</td>
                                                </tr>
                                                <tr>
                                                    <td>Loyalty Applied</td>
                                                    <td>{cartSummary.StatefulCheckoutTotalCalculated ? cartSummary.loyaltyApplied : '-'}</td>
                                                </tr>
                                            </React.Fragment>
                                        }
                                        <tr>
                                            <td>Total Discount</td>
                                            <td>{cartSummary.StatefulCheckoutTotalCalculated ? cartSummary.discount.str : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </React.Fragment>
                    }
                </div>

                <div className='cart-summary__totals'>

                    <div className='cart-summary__totals--left'>
                        SUB-TOTAL
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={cartSummary.subTotal.str}
                        dollar={true} />

                    <div className='cart-summary__totals--left'>
                        {discountLabel}
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={cartSummary.discount.str}
                        allowHidden
                        dollar={true} />

                    <div className='cart-summary__totals--left'>
                        TAX
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={cartSummary.tax.str}
                        allowHidden
                        dollar={true} />
                    
                    { UserStore.getState().selectedLocation.UseFeesDonations &&
                        <Fragment>
                            <div className='cart-summary__totals--left'>
                                {'FEES & DONATIONS'}
                            </div>
                            <Price
                                className='cart-summary__totals--right'
                                price={cartSummary.appliedFDsAmt.str}
                                allowHidden
                                dollar={true} />
                        </Fragment>
                    }
                    {cartSummary.TipAmount.flt > 0 &&
                        <Fragment>
                            <div className='cart-summary__totals--left'>
                                {'TIP'}
                            </div>
                            <Price
                                className='cart-summary__totals--right'
                                price={cartSummary.TipAmount.str}
                                allowHidden
                                dollar={true}
                            />
                        </Fragment>
                    }
                    {UserStore.getCartHasRounding()
                        && (
                            <Fragment>
                                <div className='cart-summary__totals--left'>
                                    {'ROUNDING'}
                                </div>
                                <Price
                                    className='cart-summary__totals--right'
                                    price={cartSummary.roundingAmount.str}
                                    allowHidden
                                    dollar={true}
                                />
                            </Fragment>
                        )
                    }
                </div>

                <Checkout
                    total={cartSummary.total.str}
                    guest={guest}
                    cart={cart}
                    allotment={allotment} />
            </div>
        );
    }
}

export default CartSummary;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/cart/CartSummary.react.jsx